import { useState, useLayoutEffect } from 'react';
import { SCREEN_WIDTH } from '../utils/media';
export const getViewportWidth = () => {
    return document.body.clientWidth || document.documentElement.clientWidth || window.innerWidth;
};
const useResponsiveFlags = () => {
    const [isResponsiveFlagsSet, setIsResponsiveFlagsSet] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    const [isTablet, setIsTablet] = useState(false);
    const [isDesktop, setIsDesktop] = useState(false);
    if (typeof window !== 'undefined') {
        const updateBreakpoints = () => {
            const width = getViewportWidth();
            setIsMobile(width <= SCREEN_WIDTH.MOBILE);
            setIsTablet(width <= SCREEN_WIDTH.TABLET && width > SCREEN_WIDTH.MOBILE);
            setIsDesktop(width > SCREEN_WIDTH.TABLET);
            setIsResponsiveFlagsSet(true);
        };
        /*
          Note: We invoke useLayoutEffect instead of useEffect because we need to determine the viewport width
          BEFORE rendering & painting. Invoking useEffect will cause the initial render of consumer components
          to have no flags set.
        */
        useLayoutEffect(() => {
            updateBreakpoints();
            window.addEventListener('resize', updateBreakpoints);
            return () => {
                window.removeEventListener('resize', updateBreakpoints);
            };
        });
    }
    return {
        isMobile,
        isTablet,
        isDesktop,
        isResponsiveFlagsSet,
    };
};
export default useResponsiveFlags;
